import {
  useNavigate,
  useLocation,
  useParams,
  NavigateFunction,
  Location,
  Params,
} from "react-router-dom";
import React from "react";

export interface RouterProps {
  navigate: NavigateFunction;
  location: Location;
  params: Params;
}

export const withRouter = <P extends {}>(
  Component: React.ComponentType<P & RouterProps>
): React.ComponentType<P> => {
  return (props: P) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
      />
    );
  };
};
